// import { Autocomplete, Box, Button, Card, Chip, Dialog, DialogContent, Grid, IconButton, TextField, Typography } from '@mui/material';
// import { FormikProps, getIn, setIn, setNestedObjectValues, yupToFormErrors } from 'formik';
// import React, { useEffect, useRef, useState } from 'react'
// import VariantSlider from '../../../../Component/Slider/VariantSlider';
// import { Variant } from '../../../../types/Products';
// import { ApiCreateColors, ApiCreateSize, ApiGetColors, ApiGetSizes, ApiUploadFile } from '../../../../Core/Apicall';
// import { Color } from '../../../../types/Color';
// import { Size } from '../../../../types/Size';
// import { toast } from 'react-toastify';
// import { Add, Close, CloseOutlined, CloudUploadOutlined, Delete } from '@mui/icons-material';
// import * as Yup from "yup";

// interface Props {
//   formik: FormikProps<any>;
//   variantSchema: any
//   defaultVariant: any
// }
// function VariantDetails({ formik, variantSchema, defaultVariant }: Props) {
//   const [selectedVariant, setSelectedVariant] = useState<number>(0);
//   const [selecetdVariantDetails, setSeletedVariantsDetails] = useState<Variant>()
//   const [colorlist, setColorList] = useState<Color[]>([])
//   const [sizelist, setSizeList] = useState<Size[]>([])
//   const variantFileInputRef = useRef<HTMLInputElement>(null);
//   const [openColor, setOpenColor] = useState(false);
//   const [colorName, setColorName] = useState("");
//   const [hexCode, setHexCode] = useState("#000000");
//   const [openSize, setOpenSize] = useState(false);
//   const [sizeName, setSizeName] = useState("");


//   useEffect(() => {
//     setSeletedVariantsDetails(formik.values.variants[selectedVariant])
//   }, [selectedVariant])

//   const getColors = async () => {
//     try {
//       const res = await ApiGetColors()
//       if (res?.status) {
//         setColorList(res?.data)
//       }
//     } catch (error: any) {
//       toast.error(error?.message || "Something went wrong")
//     }
//   }

//   const getSizes = async () => {
//     try {
//       const res = await ApiGetSizes()
//       if (res?.status) {
//         setSizeList(res?.data)
//       }
//     } catch (error: any) {
//       toast.error(error?.message || "Something went wrong")
//     }
//   }

//   useEffect(() => {
//     getColors()
//     getSizes()
//   }, [])


//   const handleVariantUpload = async (
//     e: React.ChangeEvent<HTMLInputElement>
//   ) => {
//     const files = Array.from(e.target.files || []);
//     if (!files.length) return;
//     try {
//       const formData = new FormData();

//       files.forEach((file) => {
//         formData.append("files", file); // or "files" depending on your backend
//       });

//       formData.append("folder", "products");

//       const res = await ApiUploadFile(formData);

//       if (res?.status) {
//         const uploadedImages = res.data.map((img: any, index: number) => ({
//           variantImageId: 0,
//           image_url: img.fileUrl,
//           alt_text: "",
//           is_thumbnail: index === 0,
//         }));
//         formik.setFieldValue(
//           `variants.${selectedVariant}.images`,
//           [
//             ...formik.values.variants[selectedVariant].images,
//             ...uploadedImages,
//           ]
//         );

//         // Allow selecting same file again
//         e.target.value = "";
//       }
      
//       } catch (error: any) {
//         toast.error(error?.message || "Something went wrong")
//       }

//     };

//     const handleAddColor = async () => {
//       try {
//         if (!colorName.trim() || !hexCode.trim()) {
//           toast.error("Please enter both color name and hex code.");
//           return;
//         }
//         const payload = {
//           name: colorName.trim(),
//           hex_code: hexCode.trim(),
//         };
//         const res = await ApiCreateColors(payload)
//         if (res?.status) {
//           getColors()
//           handleCloseColor()
//         }
//       } catch (error: any) {
//         toast.error(error?.message || "Something wnet wrong")
//       }

//     };

//     const handleAddSize = async () => {
//       try {
//         if (!sizeName.trim()) {
//           toast.error("Please enter size.");
//           return;
//         }
//         const payload = {
//           name: sizeName.trim(),
//         };
//         const res = await ApiCreateSize(payload)
//         if (res?.status) {
//           getSizes()
//           handleCloseSize()
//         }
//       } catch (error: any) {
//         toast.error(error?.message || "Something wnet wrong")
//       }

//     };

//     const handleCloseColor = () => {
//       setHexCode("")
//       setColorName("")
//       setOpenColor(false)

//     }
//     const handleCloseSize = () => {
//       setSizeName("")
//       setOpenSize(false)
//     }
//     console.log("Selcted Varinats", selectedVariant)

//     // const handleAddVariant = async () => {
//     //   try {
//     //     await variantSchema.validate(
//     //       formik.values.variants[selectedVariant],
//     //       {
//     //         abortEarly: false,
//     //       }
//     //     );

//     //     formik.setFieldValue("variants", [
//     //       ...formik.values.variants,
//     //       defaultVariant,
//     //     ]);

//     //     setSelectedVariant(formik.values.variants.length);
//     //   } catch (err: any) {
//     //     const errors: any = {};
//     //     const touched: any = {};

//     //     err.inner.forEach((error: any) => {
//     //       const path = `variants.${selectedVariant}.${error.path}`;

//     //       errors[path] = error.message;
//     //       touched[path] = true;
//     //     });

//     //     formik.setErrors(errors);
//     //     formik.setTouched(touched, true);
//     //   }
//     // };

//     const markTouched = (obj: any): any => {
//       if (Array.isArray(obj)) {
//         return obj.map(markTouched);
//       }

//       if (obj && typeof obj === "object") {
//         return Object.keys(obj).reduce((acc: any, key) => {
//           acc[key] = markTouched(obj[key]);
//           return acc;
//         }, {});
//       }

//       return true;
//     };
//     const handleAddVariant = async () => {
//       try {
//         await variantSchema.validate(
//           formik.values.variants[selectedVariant],
//           {
//             abortEarly: false,
//           }
//         );

//         formik.setFieldValue("variants", [
//           ...formik.values.variants,
//           defaultVariant,
//         ]);

//         setSelectedVariant(formik.values.variants.length);

//       } catch (err: any) {
//         const yupErrors = yupToFormErrors(err);

//         const errors = setIn(
//           {},
//           `variants.${selectedVariant}`,
//           yupErrors
//         );

//         const variantTouched = markTouched(yupErrors);

//         const touched = setIn(
//           {},
//           `variants.${selectedVariant}`,
//           variantTouched
//         );

//         console.log("Errors:", errors);
//         console.log("Touched:", touched);

//         formik.setErrors(errors);
//         formik.setTouched(touched, false);
//       }
//     };
//     console.log("Formik Errors", formik.errors);
//     console.log("Formik Touched", formik.touched);
//     console.log("Formik Values", formik.values);

//     return formik.values.variants ? (
//       <Box className='p-xl-5 px-xl-4 py-md-3 py-3 d-flex flex-column gap-2'>
//         <Box className='d-flex align-items-center justify-content-end'>
//           <Button className='btn-main' onClick={handleAddVariant}>+ Add Variant</Button>
//         </Box>
//         {formik.values.variants?.length > 1 && (
//           <Box className='border border-10'>
//             <VariantSlider
//               variants={formik.values.variants}
//               selectedVariant={selectedVariant}
//               setSelectedVariant={setSelectedVariant}
//             />
//           </Box>
//         )}
//         <Box className='p-md-3 p-1 mb-2  border-10' sx={{border:{xs:'none',md:'1px solid #ccc'}}}>
//           <Typography variant='h6' className='fw-bold'>Variant Information</Typography>
//           <hr className='my-1' />
//           <Grid container spacing={1.5} className='form-text-field'>
//             <Grid size={{ xs: 12 }} className='mt-3'>
//               <Typography className='fw-bold input-label' variant='body2' gutterBottom>Variant Name</Typography>
//               <TextField
//                 fullWidth
//                 name={`variants.${selectedVariant}.name`}
//                 placeholder="Enter Variant Name"
//                 value={formik.values.variants?.[selectedVariant]?.name || ""}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 // error={Boolean(
//                 //   (formik.touched.variants as any)?.[selectedVariant]?.name &&
//                 //   (formik.errors.variants as any)?.[selectedVariant]?.name
//                 // )}

//                 // helperText={
//                 //   (formik.touched.variants as any)?.[selectedVariant]?.name
//                 //     ? (formik.errors.variants as any)?.[selectedVariant]?.name
//                 //     : ""
//                 // }
//                 error={Boolean(
//                   getIn(formik.touched, `variants.${selectedVariant}.name`) &&
//                   getIn(formik.errors, `variants.${selectedVariant}.name`)
//                 )}

//                 helperText={
//                   getIn(formik.touched, `variants.${selectedVariant}.name`)
//                     ? getIn(formik.errors, `variants.${selectedVariant}.name`)
//                     : ""
//                 }
//               />
//             </Grid>
//             <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
//               <Box className='d-flex align-items-center justify-content-between pe-2'>
//                 <Typography className='fw-bold input-label' variant='body2' gutterBottom>Color</Typography>
//                 <Typography className='text-main pointer' onClick={() => { setOpenColor(true) }} variant='caption'>+Add New</Typography>
//               </Box>
//               <Autocomplete
//                 fullWidth
//                 options={colorlist}
//                 getOptionLabel={(option) => option.name}
//                 value={
//                   colorlist.find(
//                     (option) =>
//                       option.colorId === formik.values.variants?.[selectedVariant]?.colorId
//                   ) || null
//                 }
//                 onChange={(_, option) => {
//                   formik.setFieldValue(
//                     `variants.${selectedVariant}.colorId`,
//                     option?.colorId || ""
//                   );
//                 }}
//                 onBlur={() =>
//                   formik.setFieldTouched(
//                     `variants.${selectedVariant}.colorId`,
//                     true
//                   )
//                 }
//                 renderOption={(props, option) => (
//                   <li
//                     {...props}
//                     style={{
//                       display: "flex",
//                       alignItems: "center",
//                       gap: 10,
//                     }}
//                   >
//                     <span
//                       style={{
//                         width: 20,
//                         height: 20,
//                         borderRadius: "50%",
//                         backgroundColor: option.hex_code, // <-- your color hex
//                         border: "1px solid #ccc",
//                         display: "inline-block",
//                       }}
//                     />
//                     {option.name}
//                   </li>
//                 )}
//                 renderValue={(value) => (
//                   <Box sx={{ display: "flex", alignItems: "center", paddingLeft: '12px', gap: 1 }}>
//                     <Box
//                       sx={{
//                         width: 20,
//                         height: 20,
//                         borderRadius: "50%",
//                         bgcolor: value.hex_code,
//                         border: "1px solid #ccc",
//                       }}
//                     />
//                     {value.name}
//                   </Box>
//                 )}
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     placeholder={
//                       formik.values.variants?.[selectedVariant]?.colorId
//                         ? ""
//                         : "Select Color"
//                     }
//                     error={Boolean(
//                       getIn(
//                         formik.touched,
//                         `variants.${selectedVariant}.colorId`
//                       ) &&
//                       getIn(
//                         formik.errors,
//                         `variants.${selectedVariant}.colorId`
//                       )
//                     )}
//                     helperText={
//                       getIn(
//                         formik.touched,
//                         `variants.${selectedVariant}.colorId`
//                       )
//                         ? getIn(
//                           formik.errors,
//                           `variants.${selectedVariant}.colorId`
//                         )
//                         : ""
//                     }
//                   />
//                 )}
//               />
//             </Grid>
//             <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
//               <Box className='d-flex align-items-center justify-content-between pe-2'>
//                 <Typography className='fw-bold input-label' variant='body2' gutterBottom>Size</Typography>
//                 <Typography className='text-main pointer' variant='caption' onClick={() => { setOpenSize(true) }}>+Add New</Typography>
//               </Box>
//               <Autocomplete
//                 fullWidth
//                 options={sizelist}
//                 getOptionLabel={(option) => option.name}
//                 value={
//                   sizelist.find(
//                     (option) =>
//                       option.sizeId === formik.values.variants?.[selectedVariant]?.sizeId
//                   ) || null
//                 }
//                 onChange={(_, option) => {
//                   formik.setFieldValue(
//                     `variants.${selectedVariant}.sizeId`,
//                     option?.sizeId || ""
//                   );
//                 }}
//                 onBlur={() =>
//                   formik.setFieldTouched(
//                     `variants.${selectedVariant}.sizeId`,
//                     true
//                   )
//                 }
//                 renderInput={(params) => (
//                   <TextField
//                     {...params}
//                     placeholder="Select Size"
//                     error={Boolean(
//                       getIn(
//                         formik.touched,
//                         `variants.${selectedVariant}.sizeId`
//                       ) &&
//                       getIn(
//                         formik.errors,
//                         `variants.${selectedVariant}.sizeId`
//                       )
//                     )}
//                     helperText={
//                       getIn(
//                         formik.touched,
//                         `variants.${selectedVariant}.sizeId`
//                       )
//                         ? getIn(
//                           formik.errors,
//                           `variants.${selectedVariant}.sizeId`
//                         )
//                         : ""
//                     }
//                   />
//                 )}
//               />
//             </Grid>
//             <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
//               <Typography className='fw-bold input-label' variant='body2' gutterBottom>Price (INR)</Typography>
//               <TextField
//                 fullWidth
//                 type='number'
//                 name={`variants.${selectedVariant}.price`}
//                 placeholder="Enter Price"
//                 value={formik.values.variants?.[selectedVariant]?.price || ""}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 error={Boolean(
//                   getIn(formik.touched, `variants.${selectedVariant}.price`) &&
//                   getIn(formik.errors, `variants.${selectedVariant}.price`)
//                 )}

//                 helperText={
//                   getIn(formik.touched, `variants.${selectedVariant}.price`)
//                     ? getIn(formik.errors, `variants.${selectedVariant}.price`)
//                     : ""
//                 }
//               />
//             </Grid>
//             <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
//               <Typography className='fw-bold input-label' variant='body2' gutterBottom>Discount Percentage (%)</Typography>
//               <TextField
//                 fullWidth
//                 type='number'
//                 name={`variants.${selectedVariant}.discount_percentage`}
//                 placeholder="Enter Discount"
//                 value={formik.values.variants?.[selectedVariant]?.discount_percentage || ""}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 // error={Boolean(
//                 //   (formik.touched.variants as any)?.[selectedVariant]?.discount_percentage &&
//                 //   (formik.errors.variants as any)?.[selectedVariant]?.discount_percentage
//                 // )}

//                 // helperText={
//                 //   (formik.touched.variants as any)?.[selectedVariant]?.discount_percentage
//                 //     ? (formik.errors.variants as any)?.[selectedVariant]?.discount_percentage
//                 //     : ""
//                 // }
//                 error={Boolean(
//                   getIn(formik.touched, `variants.${selectedVariant}.discount_percentage`) &&
//                   getIn(formik.errors, `variants.${selectedVariant}.discount_percentage`)
//                 )}

//                 helperText={
//                   getIn(formik.touched, `variants.${selectedVariant}.discount_percentage`)
//                     ? getIn(formik.errors, `variants.${selectedVariant}.discount_percentage`)
//                     : ""
//                 }
//               />
//             </Grid>
//             <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
//               <Typography className='fw-bold input-label' variant='body2' gutterBottom>Discount Price</Typography>
//               <TextField
//                 fullWidth
//                 type='number'
//                 name={`variants.${selectedVariant}.discounted_price`}
//                 placeholder="Enter Discount"
//                 disabled
//                 value={(() => {
//                   const price = Number(formik.values.variants?.[selectedVariant]?.price);
//                   const discount = Number(formik.values.variants?.[selectedVariant]?.discount_percentage);
//                   if (!price || isNaN(price)) return "";
//                   const discounted = price - (discount * price) / 100;
//                   return isNaN(discounted) ? "" : discounted.toFixed(2);
//                 })()}            // onChange={formik.handleChange}
//               // onBlur={formik.handleBlur}

//               />
//             </Grid>
//             <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
//               <Typography className='fw-bold input-label' variant='body2' gutterBottom>Stock</Typography>
//               <TextField
//                 fullWidth
//                 type='number'
//                 name={`variants.${selectedVariant}.stock`}
//                 placeholder="Enter Stock"
//                 value={formik.values.variants?.[selectedVariant]?.stock || ""}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 // error={Boolean(
//                 //   (formik.touched.variants as any)?.[selectedVariant]?.stock &&
//                 //   (formik.errors.variants as any)?.[selectedVariant]?.stock
//                 // )}

//                 // helperText={
//                 //   (formik.touched.variants as any)?.[selectedVariant]?.stock
//                 //     ? (formik.errors.variants as any)?.[selectedVariant]?.stock
//                 //     : ""
//                 // }

//                 error={Boolean(
//                   getIn(formik.touched, `variants.${selectedVariant}.stock`) &&
//                   getIn(formik.errors, `variants.${selectedVariant}.stock`)
//                 )}

//                 helperText={
//                   getIn(formik.touched, `variants.${selectedVariant}.stock`)
//                     ? getIn(formik.errors, `variants.${selectedVariant}.stock`)
//                     : ""
//                 }
//               />
//             </Grid>
//             <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
//               <Typography className='fw-bold input-label' variant='body2' gutterBottom>Unit Text</Typography>
//               <TextField
//                 fullWidth
//                 name={`variants.${selectedVariant}.unit_text`}
//                 placeholder="Enter Discount"
//                 value={formik.values.variants?.[selectedVariant]?.unit_text || ""}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 // error={Boolean(
//                 //   (formik.touched.variants as any)?.[selectedVariant]?.unit_text &&
//                 //   (formik.errors.variants as any)?.[selectedVariant]?.unit_text
//                 // )}

//                 // helperText={
//                 //   (formik.touched.variants as any)?.[selectedVariant]?.unit_text
//                 //     ? (formik.errors.variants as any)?.[selectedVariant]?.unit_text
//                 //     : ""
//                 // }
//                 error={Boolean(
//                   getIn(formik.touched, `variants.${selectedVariant}.unit_text`) &&
//                   getIn(formik.errors, `variants.${selectedVariant}.unit_text`)
//                 )}

//                 helperText={
//                   getIn(formik.touched, `variants.${selectedVariant}.unit_text`)
//                     ? getIn(formik.errors, `variants.${selectedVariant}.unit_text`)
//                     : ""
//                 }
//               />
//             </Grid>
//             <Grid size={{ xs: 12, md: 6 }} className='mt-3'>
//               <Typography className='fw-bold input-label' variant='body2' gutterBottom>Min Delivery Days</Typography>
//               <TextField
//                 fullWidth
//                 type='number'
//                 name={`variants.${selectedVariant}.min_delivery_days`}
//                 placeholder="Enter Min Days"
//                 value={formik.values.variants?.[selectedVariant]?.min_delivery_days || ""}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 // error={Boolean(
//                 //   (formik.touched.variants as any)?.[selectedVariant]?.min_delivery_days &&
//                 //   (formik.errors.variants as any)?.[selectedVariant]?.min_delivery_days
//                 // )}

//                 // helperText={
//                 //   (formik.touched.variants as any)?.[selectedVariant]?.min_delivery_days
//                 //     ? (formik.errors.variants as any)?.[selectedVariant]?.min_delivery_days
//                 //     : ""
//                 // }
//                 error={Boolean(
//                   getIn(formik.touched, `variants.${selectedVariant}.min_delivery_days`) &&
//                   getIn(formik.errors, `variants.${selectedVariant}.min_delivery_days`)
//                 )}

//                 helperText={
//                   getIn(formik.touched, `variants.${selectedVariant}.min_delivery_days`)
//                     ? getIn(formik.errors, `variants.${selectedVariant}.min_delivery_days`)
//                     : ""
//                 }
//               />
//             </Grid>
//             <Grid size={{ xs: 12, md: 6 }} className='mt-3'>
//               <Typography className='fw-bold input-label' variant='body2' gutterBottom>Max Delivery Days</Typography>
//               <TextField
//                 fullWidth
//                 type='number'
//                 name={`variants.${selectedVariant}.max_delivery_days`}
//                 placeholder="Enter Min Days"
//                 value={formik.values.variants?.[selectedVariant]?.max_delivery_days || ""}
//                 onChange={formik.handleChange}
//                 onBlur={formik.handleBlur}
//                 // error={Boolean(
//                 //   (formik.touched.variants as any)?.[selectedVariant]?.max_delivery_days &&
//                 //   (formik.errors.variants as any)?.[selectedVariant]?.max_delivery_days
//                 // )}

//                 // helperText={
//                 //   (formik.touched.variants as any)?.[selectedVariant]?.max_delivery_days
//                 //     ? (formik.errors.variants as any)?.[selectedVariant]?.max_delivery_days
//                 //     : ""
//                 // }
//                 error={Boolean(
//                   getIn(formik.touched, `variants.${selectedVariant}.max_delivery_days`) &&
//                   getIn(formik.errors, `variants.${selectedVariant}.max_delivery_days`)
//                 )}

//                 helperText={
//                   getIn(formik.touched, `variants.${selectedVariant}.max_delivery_days`)
//                     ? getIn(formik.errors, `variants.${selectedVariant}.max_delivery_days`)
//                     : ""
//                 }
//               />

//             </Grid>
//             <Grid size={{ xs: 12, md: 6 }} className='mt-3'>
//               <Card elevation={0} className="bg-transparent border p-3 border-10">
//                 <Typography variant="h6" className="fw-bold mb-3">
//                   Technical Details
//                 </Typography>

//                 <Grid container className="bg-grey p-2 mb-2">
//                   <Grid size="grow">Key</Grid>
//                   <Grid size="grow">Value</Grid>
//                   <Grid size={{ xs: 1 }} />
//                 </Grid>

//                 {formik.values.variants[selectedVariant]?.technicalDetails?.map(
//                   (item: any, index: number) => (
//                     <Grid container spacing={1} key={index} className="mb-2 align-items-center">
//                       <Grid size="grow">
//                         <TextField
//                           fullWidth
//                           size="small"
//                           placeholder="Key"
//                           name={`variants.${selectedVariant}.technicalDetails.[${index}].key`}
//                           value={item.key}
//                           onChange={formik.handleChange}
//                           error={Boolean(
//                             getIn(formik.touched, `variants.${selectedVariant}.technicalDetails.${index}.key`) &&
//                             getIn(formik.errors, `variants.${selectedVariant}.technicalDetails.${index}.key`)
//                           )}

//                           helperText={
//                             getIn(formik.touched, `variants.${selectedVariant}.technicalDetails.${index}.key`)
//                               ? getIn(formik.errors, `variants.${selectedVariant}.technicalDetails.${index}.key`)
//                               : ""
//                           }
//                         />
//                       </Grid>

//                       <Grid size="grow">
//                         <TextField
//                           fullWidth
//                           size="small"
//                           placeholder="Value"
//                           name={`variants.${selectedVariant}.technicalDetails.${index}.value`}
//                           value={item.value}
//                           onChange={formik.handleChange}
//                           error={Boolean(
//                             getIn(formik.touched, `variants.${selectedVariant}.technicalDetails.${index}.value`) &&
//                             getIn(formik.errors, `variants.${selectedVariant}.technicalDetails.${index}.value`)
//                           )}

//                           helperText={
//                             getIn(formik.touched, `variants.${selectedVariant}.technicalDetails.${index}.value`)
//                               ? getIn(formik.errors, `variants.${selectedVariant}.technicalDetails.${index}.value`)
//                               : ""
//                           }
//                         />
//                       </Grid>

//                       <Grid size={{ xs: 1 }} className="text-center">
//                         <IconButton
//                           color="error"
//                           disabled={
//                             formik.values.variants[selectedVariant].technicalDetails.length === 1
//                           }
//                           onClick={() => {
//                             const data = [
//                               ...formik.values.variants[selectedVariant].technicalDetails,
//                             ];
//                             data.splice(index, 1);

//                             formik.setFieldValue(
//                               `variants.${selectedVariant}.technicalDetails`,
//                               data
//                             );
//                           }}
//                         >
//                           <Delete fontSize="small" />
//                         </IconButton>
//                       </Grid>
//                     </Grid>
//                   )
//                 )}

//                 <Button
//                   startIcon={<Add />}
//                   variant="outlined"
//                   className="btn-outlined-main"
//                   sx={{ mt: 1 }}
//                   onClick={() => {
//                     formik.setFieldValue(
//                       `variants.${selectedVariant}.technicalDetails`,
//                       [
//                         ...formik.values.variants[selectedVariant].technicalDetails,
//                         {
//                           technicalDetailId: "",
//                           key: "",
//                           value: "",
//                         },
//                       ]
//                     );
//                   }}
//                 >
//                   Add Technical Detail
//                 </Button>
//               </Card>
//             </Grid>
//             <Grid size={{ xs: 12, md: 6 }} className='mt-3'>
//               <Card elevation={0} className="bg-transparent border p-3 border-10">
//                 <Typography variant="h6" className="fw-bold mb-3">
//                   Wholesale Price Tiers
//                 </Typography>
//                 <Grid container className="bg-grey p-2 mb-2">
//                   <Grid size="grow">Min Quantity</Grid>
//                   <Grid size="grow">Price (₹)</Grid>
//                   <Grid size={{ xs: 1 }} />
//                 </Grid>

//                 {formik.values.variants[selectedVariant]?.wholesalePriceTiers?.map(
//                   (item: any, index: number) => (
//                     <Grid container spacing={1} key={index} className="mb-2 align-items-center">
//                       <Grid size="grow">
//                         <TextField
//                           fullWidth
//                           size="small"
//                           type="number"
//                           placeholder="Min Qty"
//                           name={`variants.${selectedVariant}.wholesalePriceTiers.${index}.min_quantity`}
//                           value={item.min_quantity}
//                           onChange={formik.handleChange}
//                           error={Boolean(
//                             getIn(formik.touched, `variants.${selectedVariant}.wholesalePriceTiers.${index}.min_quantity`) &&
//                             getIn(formik.errors, `variants.${selectedVariant}.wholesalePriceTiers.${index}.min_quantity`)
//                           )}

//                           helperText={
//                             getIn(formik.touched, `variants.${selectedVariant}.wholesalePriceTiers.${index}.min_quantity`)
//                               ? getIn(formik.errors, `variants.${selectedVariant}.wholesalePriceTiers.${index}.min_quantity`)
//                               : ""
//                           }
//                         />
//                       </Grid>

//                       <Grid size="grow">
//                         <TextField
//                           fullWidth
//                           size="small"
//                           type="number"
//                           placeholder="Price"
//                           name={`variants.${selectedVariant}.wholesalePriceTiers.${index}.price`}
//                           value={item.price}
//                           onChange={formik.handleChange}
//                           error={Boolean(
//                             getIn(formik.touched, `variants.${selectedVariant}.wholesalePriceTiers.${index}.price`) &&
//                             getIn(formik.errors, `variants.${selectedVariant}.wholesalePriceTiers.${index}.price`)
//                           )}

//                           helperText={
//                             getIn(formik.touched, `variants.${selectedVariant}.wholesalePriceTiers.${index}.price`)
//                               ? getIn(formik.errors, `variants.${selectedVariant}.wholesalePriceTiers.${index}.price`)
//                               : ""
//                           }
//                         />
//                       </Grid>

//                       <Grid size={{ xs: 1 }} className="text-center">
//                         <IconButton
//                           color="error"
//                           disabled={
//                             formik.values.variants[selectedVariant].wholesalePriceTiers
//                               .length === 1
//                           }
//                           onClick={() => {
//                             const data = [
//                               ...formik.values.variants[selectedVariant]
//                                 .wholesalePriceTiers,
//                             ];
//                             data.splice(index, 1);

//                             formik.setFieldValue(
//                               `variants.${selectedVariant}.wholesalePriceTiers`,
//                               data
//                             );
//                           }}
//                         >
//                           <Delete fontSize="small" />
//                         </IconButton>
//                       </Grid>
//                     </Grid>
//                   )
//                 )}

//                 <Button
//                   startIcon={<Add />}
//                   variant="outlined"
//                   className="btn-outlined-main"
//                   sx={{ mt: 1 }}
//                   onClick={() => {
//                     formik.setFieldValue(
//                       `variants.${selectedVariant}.wholesalePriceTiers`,
//                       [
//                         ...formik.values.variants[selectedVariant]
//                           .wholesalePriceTiers,
//                         {
//                           tierId: "",
//                           min_quantity: "",
//                           price: "",
//                         },
//                       ]
//                     );
//                   }}
//                 >
//                   Add Tier
//                 </Button>
//               </Card>
//             </Grid>
//             <Grid size={{ xs: 12}} >
//             <Box className="p-3 mb-2">
//               <Typography variant="h6" className="fw-bold">
//                 Variant Images
//               </Typography>

//               <hr className="my-1" />

//               <Grid container spacing={1.5} className="mt-4 ">
//                 <Grid size={{ xs: 12, md: "auto" }}>
//                   <Box
//                     className="p-4 d-flex flex-column border-10 justify-content-center text-center align-items-center"
//                     sx={{
//                       border: "2px dashed #d6d6d6",
//                       cursor: "pointer",
//                     }}
//                     onClick={() => variantFileInputRef.current?.click()}
//                   >
//                     <CloudUploadOutlined sx={{ fontSize: 35, color: "#777" }} />

//                     <Typography className="mt-1" variant="body1">
//                       Drag & drop images here
//                     </Typography>

//                     <Typography className="my-1" variant="body2" color="text.secondary">
//                       or
//                     </Typography>

//                     <Button
//                       variant="outlined"
//                       className="btn-outlined-main my-2"
//                       size="small"
//                       onClick={(e) => {
//                         e.stopPropagation();
//                         variantFileInputRef.current?.click();
//                       }}
//                     >
//                       Upload Images
//                     </Button>

//                     <Typography
//                       className="mt-1"
//                       variant="caption"
//                       color="text.secondary"
//                       sx={{ fontSize: 10 }}
//                     >
//                       PNG or JPG. Max size 5MB
//                     </Typography>

//                     <input
//                       ref={variantFileInputRef}
//                       type="file"
//                       hidden
//                       multiple
//                       accept="image/*"
//                       onChange={handleVariantUpload}
//                     />
//                   </Box>
//                 </Grid>

//                 <Grid size={{ xs: 12, md: "grow" }}>
//                   <Box
//                     sx={{
//                       display: "grid",
//                       gridTemplateColumns: {
//                         xs: "repeat(2,1fr)",
//                         sm: "repeat(3,1fr)",
//                         md: "repeat(4,1fr)",
//                       },
//                       gap: 2,
//                     }}
//                   >
//                     {formik.values.variants[selectedVariant]?.images?.map(
//                       (item: any, index: number) => (
//                         <Box
//                           key={index}
//                           sx={{
//                             border: "1px solid #e0e0e0",
//                             borderRadius: 2,
//                             overflow: "hidden",
//                             position: "relative",
//                             background: "#fff",
//                             // height: 170,
//                           }}
//                         >
//                           <IconButton
//                             size="small"
//                             sx={{
//                               position: "absolute",
//                               top: 5,
//                               right: 5,
//                               bgcolor: "#fff",
//                               zIndex: 1,
//                             }}
//                             onClick={() => {
//                               const images = [
//                                 ...formik.values.variants[selectedVariant].images,
//                               ];

//                               images.splice(index, 1);

//                               formik.setFieldValue(
//                                 `variants.${selectedVariant}.images`,
//                                 images
//                               );
//                             }}
//                           >
//                             <Close fontSize="small" />
//                           </IconButton>

//                           <Box
//                             component="img"
//                             src={item.image_url}
//                             alt={item.alt_text || `Variant ${index + 1}`}
//                             sx={{
//                               width: "100%",
//                               // height: 120,
//                               objectFit: "contain",
//                               p: 1,
//                             }}
//                           />

//                           {item.is_thumbnail && (
//                             <Chip
//                               label="Thumbnail"
//                               color="success"
//                               size="small"
//                               sx={{
//                                 position: "absolute",
//                                 bottom: 8,
//                                 left: "50%",
//                                 transform: "translateX(-50%)",
//                               }}
//                             />
//                           )}
//                         </Box>
//                       )
//                     )}
//                   </Box>
//                 </Grid>
//               </Grid>
//             </Box>
//             </Grid>
//           </Grid>
//         </Box>
//         <Dialog
//           open={openColor}
//           maxWidth="sm"
//           fullWidth
//           slotProps={{
//             paper: {
//               sx: {
//                 width: 480,
//                 borderRadius: "10px",
//                 p: 1,
//               },
//             },
//           }}
//         >
//           <DialogContent sx={{ p: 2 }}>
//             {/* Header */}
//             <Box className="d-flex align-items-center justify-content-between mb-3">
//               <Typography variant="h6" className="fw-bold">
//                 Add Color
//               </Typography>

//               <IconButton size="small" onClick={handleCloseColor}>
//                 <CloseOutlined />
//               </IconButton>
//             </Box>

//             {/* Color Name */}
//             <Box className="mb-3">
//               <Typography
//                 variant="body2"
//                 className="fw-bold mb-1"
//               >
//                 Color Name <span style={{ color: "red" }}>*</span>
//               </Typography>

//               <TextField
//                 fullWidth
//                 size="small"
//                 placeholder="Enter color name"
//                 value={colorName}
//                 onChange={(e) => setColorName(e.target.value)}
//               />
//             </Box>

//             <Box className="mb-3">
//               <Typography
//                 variant="body2"
//                 className="fw-bold mb-1"
//               >
//                 Hex Code <span style={{ color: "red" }}>*</span>
//               </Typography>

//               <Box className="d-flex align-items-center gap-2">
//                 <TextField
//                   fullWidth
//                   size="small"
//                   placeholder="#000000"
//                   value={hexCode}
//                   onChange={(e) => setHexCode(e.target.value)}
//                 />

//                 <TextField
//                   type="color"
//                   value={hexCode}
//                   onChange={(e) => setHexCode(e.target.value)}
//                   sx={{
//                     width: 60,
//                     "& input": {
//                       cursor: "pointer",
//                       padding: "4px",
//                       height: "40px",
//                     },
//                   }}
//                 />
//               </Box>
//             </Box>

//             <Box className="d-flex justify-content-end gap-2">
//               <Button
//                 variant="outlined"
//                 className="btn-outlined-main"
//                 onClick={handleCloseColor}
//               >
//                 Cancel
//               </Button>

//               <Button
//                 className="btn-main"
//                 onClick={handleAddColor}
//               >
//                 Save
//               </Button>
//             </Box>
//           </DialogContent>
//         </Dialog>

//         <Dialog
//           open={openSize}
//           maxWidth="sm"
//           fullWidth
//           slotProps={{
//             paper: {
//               sx: {
//                 width: 480,
//                 borderRadius: "10px",
//                 p: 1,
//               },
//             },
//           }}
//         >
//           <DialogContent sx={{ p: 2 }}>
//             {/* Header */}
//             <Box className="d-flex align-items-center justify-content-between mb-3">
//               <Typography variant="h6" className="fw-bold">
//                 Add Size
//               </Typography>

//               <IconButton size="small" onClick={handleCloseSize}>
//                 <CloseOutlined />
//               </IconButton>
//             </Box>

//             {/* Size Name */}
//             <Box className="mb-3">
//               <Typography
//                 variant="body2"
//                 className="fw-bold mb-1"
//               >
//                 Size Name <span style={{ color: "red" }}>*</span>
//               </Typography>

//               <TextField
//                 fullWidth
//                 size="small"
//                 placeholder="Enter size name"
//                 value={sizeName}
//                 onChange={(e) => setSizeName(e.target.value)}
//               />
//             </Box>

//             {/* Buttons */}
//             <Box className="d-flex justify-content-end gap-2">
//               <Button
//                 variant="outlined"
//                 className="btn-outlined-main"
//                 onClick={handleCloseSize}
//               >
//                 Cancel
//               </Button>

//               <Button
//                 className="btn-main"
//                 onClick={handleAddSize}
//               >
//                 Save
//               </Button>
//             </Box>
//           </DialogContent>
//         </Dialog>

//       </Box>
//     )
//       : (<></>)
//   }

//   export default VariantDetails

import { Autocomplete, Box, Button, Card, Chip, Dialog, DialogContent, Grid, IconButton, TextField, Tooltip, Typography } from '@mui/material';
import { FormikProps, getIn, setIn, setNestedObjectValues, yupToFormErrors } from 'formik';
import React, { useEffect, useRef, useState } from 'react'
import VariantSlider from '../../../../Component/Slider/VariantSlider';
import { Variant } from '../../../../types/Products';
import { ApiCreateColors, ApiCreateSize, ApiGetColors, ApiGetSizes, ApiUploadFile } from '../../../../Core/Apicall';
import { Color } from '../../../../types/Color';
import { Size } from '../../../../types/Size';
import { toast } from 'react-toastify';
import { Add, Close, CloseOutlined, CloudUploadOutlined, Delete } from '@mui/icons-material';
import * as Yup from "yup";

interface Props {
  formik: FormikProps<any>;
  variantSchema: any
  defaultVariant: any
}
function VariantDetails({ formik, variantSchema, defaultVariant }: Props) {
  const [selectedVariant, setSelectedVariant] = useState<number>(0);
  const [selecetdVariantDetails, setSeletedVariantsDetails] = useState<Variant>()
  const [colorlist, setColorList] = useState<Color[]>([])
  const [sizelist, setSizeList] = useState<Size[]>([])
  const variantFileInputRef = useRef<HTMLInputElement>(null);
  const [openColor, setOpenColor] = useState(false);
  const [colorName, setColorName] = useState("");
  const [hexCode, setHexCode] = useState("#000000");
  const [openSize, setOpenSize] = useState(false);
  const [sizeName, setSizeName] = useState("");
  const [openDeleteVariant, setOpenDeleteVariant] = useState(false);


  useEffect(() => {
    setSeletedVariantsDetails(formik.values.variants[selectedVariant])
  }, [selectedVariant])

  const getColors = async () => {
    try {
      const res = await ApiGetColors()
      if (res?.status) {
        setColorList(res?.data)
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong")
    }
  }

  const getSizes = async () => {
    try {
      const res = await ApiGetSizes()
      if (res?.status) {
        setSizeList(res?.data)
      }
    } catch (error: any) {
      toast.error(error?.message || "Something went wrong")
    }
  }

  useEffect(() => {
    getColors()
    getSizes()
  }, [])


  const handleVariantUpload = async (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    try {
      const formData = new FormData();

      files.forEach((file) => {
        formData.append("files", file); // or "files" depending on your backend
      });

      formData.append("folder", "products");

      const res = await ApiUploadFile(formData);

      if (res?.status) {
        const uploadedImages = res.data.map((img: any, index: number) => ({
          variantImageId: 0,
          image_url: img.fileUrl,
          alt_text: "",
          is_thumbnail: index === 0,
        }));
        formik.setFieldValue(
          `variants.${selectedVariant}.images`,
          [
            ...formik.values.variants[selectedVariant].images,
            ...uploadedImages,
          ]
        );

        // Allow selecting same file again
        e.target.value = "";
      }
      
      } catch (error: any) {
        toast.error(error?.message || "Something went wrong")
      }

    };

    const handleAddColor = async () => {
      try {
        if (!colorName.trim() || !hexCode.trim()) {
          toast.error("Please enter both color name and hex code.");
          return;
        }
        const payload = {
          name: colorName.trim(),
          hex_code: hexCode.trim(),
        };
        const res = await ApiCreateColors(payload)
        if (res?.status) {
          getColors()
          handleCloseColor()
        }
      } catch (error: any) {
        toast.error(error?.message || "Something wnet wrong")
      }

    };

    const handleAddSize = async () => {
      try {
        if (!sizeName.trim()) {
          toast.error("Please enter size.");
          return;
        }
        const payload = {
          name: sizeName.trim(),
        };
        const res = await ApiCreateSize(payload)
        if (res?.status) {
          getSizes()
          handleCloseSize()
        }
      } catch (error: any) {
        toast.error(error?.message || "Something wnet wrong")
      }

    };

    const handleCloseColor = () => {
      setHexCode("")
      setColorName("")
      setOpenColor(false)

    }
    const handleCloseSize = () => {
      setSizeName("")
      setOpenSize(false)
    }
    const canDeleteVariant = (formik.values.variants?.length || 0) > 1;

    // Drops the selected variant's entry from formik.errors.variants / formik.touched.variants
    // so remaining variants keep the correct error/touched state after re-indexing.
    // Removes the "variants" key entirely when nothing is left (otherwise formik.isValid stays false).
    const removeSelectedFromFormikState = (state: any) => {
      const next = { ...state };
      if (Array.isArray(next.variants)) {
        const arr = Array.from(next.variants).filter((_, i) => i !== selectedVariant);
        if (arr.some(Boolean)) {
          next.variants = arr;
        } else {
          delete next.variants;
        }
      }
      return next;
    };

    const handleDeleteVariant = () => {
      const variants = formik.values.variants || [];

      // Guard: at least one variant must always remain
      if (variants.length <= 1) {
        toast.error("At least one variant is required.");
        setOpenDeleteVariant(false);
        return;
      }

      const updatedVariants = variants.filter((_: any, i: number) => i !== selectedVariant);
      // Same index now points to the next variant; if the last one was removed, step back
      const nextIndex = Math.min(selectedVariant, updatedVariants.length - 1);

      formik.setFormikState((prev) => ({
        ...prev,
        values: { ...prev.values, variants: updatedVariants },
        errors: removeSelectedFromFormikState(prev.errors),
        touched: removeSelectedFromFormikState(prev.touched),
      }));

      setSelectedVariant(nextIndex);
      setSeletedVariantsDetails(updatedVariants[nextIndex]);
      setOpenDeleteVariant(false);
      toast.success("Variant removed. Save the product to apply changes.");
    };

    console.log("Selcted Varinats", selectedVariant)

    // const handleAddVariant = async () => {
    //   try {
    //     await variantSchema.validate(
    //       formik.values.variants[selectedVariant],
    //       {
    //         abortEarly: false,
    //       }
    //     );

    //     formik.setFieldValue("variants", [
    //       ...formik.values.variants,
    //       defaultVariant,
    //     ]);

    //     setSelectedVariant(formik.values.variants.length);
    //   } catch (err: any) {
    //     const errors: any = {};
    //     const touched: any = {};

    //     err.inner.forEach((error: any) => {
    //       const path = `variants.${selectedVariant}.${error.path}`;

    //       errors[path] = error.message;
    //       touched[path] = true;
    //     });

    //     formik.setErrors(errors);
    //     formik.setTouched(touched, true);
    //   }
    // };

    const markTouched = (obj: any): any => {
      if (Array.isArray(obj)) {
        return obj.map(markTouched);
      }

      if (obj && typeof obj === "object") {
        return Object.keys(obj).reduce((acc: any, key) => {
          acc[key] = markTouched(obj[key]);
          return acc;
        }, {});
      }

      return true;
    };
    const handleAddVariant = async () => {
      try {
        await variantSchema.validate(
          formik.values.variants[selectedVariant],
          {
            abortEarly: false,
          }
        );

        formik.setFieldValue("variants", [
          ...formik.values.variants,
          defaultVariant,
        ]);

        setSelectedVariant(formik.values.variants.length);

      } catch (err: any) {
        const yupErrors = yupToFormErrors(err);

        const errors = setIn(
          {},
          `variants.${selectedVariant}`,
          yupErrors
        );

        const variantTouched = markTouched(yupErrors);

        const touched = setIn(
          {},
          `variants.${selectedVariant}`,
          variantTouched
        );

        console.log("Errors:", errors);
        console.log("Touched:", touched);

        formik.setErrors(errors);
        formik.setTouched(touched, false);
      }
    };
    console.log("Formik Errors", formik.errors);
    console.log("Formik Touched", formik.touched);
    console.log("Formik Values", formik.values);

    return formik.values.variants ? (
      <Box className='p-xl-5 px-xl-4 py-md-3 py-3 d-flex flex-column gap-2'>
        <Box className='d-flex align-items-center justify-content-end'>
          <Button className='btn-main' onClick={handleAddVariant}>+ Add Variant</Button>
        </Box>
        {formik.values.variants?.length > 1 && (
          <Box className='border border-10'>
            <VariantSlider
              variants={formik.values.variants}
              selectedVariant={selectedVariant}
              setSelectedVariant={setSelectedVariant}
            />
          </Box>
        )}
        <Box className='p-md-3 p-1 mb-2  border-10' sx={{border:{xs:'none',md:'1px solid #ccc'}}}>
          <Box className='d-flex align-items-center justify-content-between'>
            <Typography variant='h6' className='fw-bold'>Variant Information</Typography>
            <Tooltip title={canDeleteVariant ? "Delete this variant" : "At least one variant is required"}>
              {/* span lets the tooltip work while the button is disabled */}
              <span>
                <Button
                  variant="outlined"
                  color="error"
                  size="small"
                  startIcon={<Delete />}
                  disabled={!canDeleteVariant}
                  onClick={() => setOpenDeleteVariant(true)}
                >
                  Delete Variant
                </Button>
              </span>
            </Tooltip>
          </Box>
          <hr className='my-1' />
          <Grid container spacing={1.5} className='form-text-field'>
            <Grid size={{ xs: 12 }} className='mt-3'>
              <Typography className='fw-bold input-label' variant='body2' gutterBottom>Variant Name</Typography>
              <TextField
                fullWidth
                name={`variants.${selectedVariant}.name`}
                placeholder="Enter Variant Name"
                value={formik.values.variants?.[selectedVariant]?.name || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                // error={Boolean(
                //   (formik.touched.variants as any)?.[selectedVariant]?.name &&
                //   (formik.errors.variants as any)?.[selectedVariant]?.name
                // )}

                // helperText={
                //   (formik.touched.variants as any)?.[selectedVariant]?.name
                //     ? (formik.errors.variants as any)?.[selectedVariant]?.name
                //     : ""
                // }
                error={Boolean(
                  getIn(formik.touched, `variants.${selectedVariant}.name`) &&
                  getIn(formik.errors, `variants.${selectedVariant}.name`)
                )}

                helperText={
                  getIn(formik.touched, `variants.${selectedVariant}.name`)
                    ? getIn(formik.errors, `variants.${selectedVariant}.name`)
                    : ""
                }
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
              <Box className='d-flex align-items-center justify-content-between pe-2'>
                <Typography className='fw-bold input-label' variant='body2' gutterBottom>Color</Typography>
                <Typography className='text-main pointer' onClick={() => { setOpenColor(true) }} variant='caption'>+Add New</Typography>
              </Box>
              <Autocomplete
                fullWidth
                options={colorlist}
                getOptionLabel={(option) => option.name}
                value={
                  colorlist.find(
                    (option) =>
                      option.colorId === formik.values.variants?.[selectedVariant]?.colorId
                  ) || null
                }
                onChange={(_, option) => {
                  formik.setFieldValue(
                    `variants.${selectedVariant}.colorId`,
                    option?.colorId || ""
                  );
                }}
                onBlur={() =>
                  formik.setFieldTouched(
                    `variants.${selectedVariant}.colorId`,
                    true
                  )
                }
                renderOption={(props, option) => (
                  <li
                    {...props}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                  >
                    <span
                      style={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        backgroundColor: option.hex_code, // <-- your color hex
                        border: "1px solid #ccc",
                        display: "inline-block",
                      }}
                    />
                    {option.name}
                  </li>
                )}
                renderValue={(value) => (
                  <Box sx={{ display: "flex", alignItems: "center", paddingLeft: '12px', gap: 1 }}>
                    <Box
                      sx={{
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        bgcolor: value.hex_code,
                        border: "1px solid #ccc",
                      }}
                    />
                    {value.name}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={
                      formik.values.variants?.[selectedVariant]?.colorId
                        ? ""
                        : "Select Color"
                    }
                    error={Boolean(
                      getIn(
                        formik.touched,
                        `variants.${selectedVariant}.colorId`
                      ) &&
                      getIn(
                        formik.errors,
                        `variants.${selectedVariant}.colorId`
                      )
                    )}
                    helperText={
                      getIn(
                        formik.touched,
                        `variants.${selectedVariant}.colorId`
                      )
                        ? getIn(
                          formik.errors,
                          `variants.${selectedVariant}.colorId`
                        )
                        : ""
                    }
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
              <Box className='d-flex align-items-center justify-content-between pe-2'>
                <Typography className='fw-bold input-label' variant='body2' gutterBottom>Size</Typography>
                <Typography className='text-main pointer' variant='caption' onClick={() => { setOpenSize(true) }}>+Add New</Typography>
              </Box>
              <Autocomplete
                fullWidth
                options={sizelist}
                getOptionLabel={(option) => option.name}
                value={
                  sizelist.find(
                    (option) =>
                      option.sizeId === formik.values.variants?.[selectedVariant]?.sizeId
                  ) || null
                }
                onChange={(_, option) => {
                  formik.setFieldValue(
                    `variants.${selectedVariant}.sizeId`,
                    option?.sizeId || ""
                  );
                }}
                onBlur={() =>
                  formik.setFieldTouched(
                    `variants.${selectedVariant}.sizeId`,
                    true
                  )
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder="Select Size"
                    error={Boolean(
                      getIn(
                        formik.touched,
                        `variants.${selectedVariant}.sizeId`
                      ) &&
                      getIn(
                        formik.errors,
                        `variants.${selectedVariant}.sizeId`
                      )
                    )}
                    helperText={
                      getIn(
                        formik.touched,
                        `variants.${selectedVariant}.sizeId`
                      )
                        ? getIn(
                          formik.errors,
                          `variants.${selectedVariant}.sizeId`
                        )
                        : ""
                    }
                  />
                )}
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
              <Typography className='fw-bold input-label' variant='body2' gutterBottom>Price (INR)</Typography>
              <TextField
                fullWidth
                type='number'
                name={`variants.${selectedVariant}.price`}
                placeholder="Enter Price"
                value={formik.values.variants?.[selectedVariant]?.price || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={Boolean(
                  getIn(formik.touched, `variants.${selectedVariant}.price`) &&
                  getIn(formik.errors, `variants.${selectedVariant}.price`)
                )}

                helperText={
                  getIn(formik.touched, `variants.${selectedVariant}.price`)
                    ? getIn(formik.errors, `variants.${selectedVariant}.price`)
                    : ""
                }
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
              <Typography className='fw-bold input-label' variant='body2' gutterBottom>Discount Percentage (%)</Typography>
              <TextField
                fullWidth
                type='number'
                name={`variants.${selectedVariant}.discount_percentage`}
                placeholder="Enter Discount"
                value={formik.values.variants?.[selectedVariant]?.discount_percentage || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                // error={Boolean(
                //   (formik.touched.variants as any)?.[selectedVariant]?.discount_percentage &&
                //   (formik.errors.variants as any)?.[selectedVariant]?.discount_percentage
                // )}

                // helperText={
                //   (formik.touched.variants as any)?.[selectedVariant]?.discount_percentage
                //     ? (formik.errors.variants as any)?.[selectedVariant]?.discount_percentage
                //     : ""
                // }
                error={Boolean(
                  getIn(formik.touched, `variants.${selectedVariant}.discount_percentage`) &&
                  getIn(formik.errors, `variants.${selectedVariant}.discount_percentage`)
                )}

                helperText={
                  getIn(formik.touched, `variants.${selectedVariant}.discount_percentage`)
                    ? getIn(formik.errors, `variants.${selectedVariant}.discount_percentage`)
                    : ""
                }
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
              <Typography className='fw-bold input-label' variant='body2' gutterBottom>Discount Price</Typography>
              <TextField
                fullWidth
                type='number'
                name={`variants.${selectedVariant}.discounted_price`}
                placeholder="Enter Discount"
                disabled
                value={(() => {
                  const price = Number(formik.values.variants?.[selectedVariant]?.price);
                  const discount = Number(formik.values.variants?.[selectedVariant]?.discount_percentage);
                  if (!price || isNaN(price)) return "";
                  const discounted = price - (discount * price) / 100;
                  return isNaN(discounted) ? "" : discounted.toFixed(2);
                })()}            // onChange={formik.handleChange}
              // onBlur={formik.handleBlur}

              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
              <Typography className='fw-bold input-label' variant='body2' gutterBottom>Stock</Typography>
              <TextField
                fullWidth
                type='number'
                name={`variants.${selectedVariant}.stock`}
                placeholder="Enter Stock"
                value={formik.values.variants?.[selectedVariant]?.stock || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                // error={Boolean(
                //   (formik.touched.variants as any)?.[selectedVariant]?.stock &&
                //   (formik.errors.variants as any)?.[selectedVariant]?.stock
                // )}

                // helperText={
                //   (formik.touched.variants as any)?.[selectedVariant]?.stock
                //     ? (formik.errors.variants as any)?.[selectedVariant]?.stock
                //     : ""
                // }

                error={Boolean(
                  getIn(formik.touched, `variants.${selectedVariant}.stock`) &&
                  getIn(formik.errors, `variants.${selectedVariant}.stock`)
                )}

                helperText={
                  getIn(formik.touched, `variants.${selectedVariant}.stock`)
                    ? getIn(formik.errors, `variants.${selectedVariant}.stock`)
                    : ""
                }
              />
            </Grid>
            <Grid size={{ xs: 12, md: 3 }} className='mt-3'>
              <Typography className='fw-bold input-label' variant='body2' gutterBottom>Unit Text</Typography>
              <TextField
                fullWidth
                name={`variants.${selectedVariant}.unit_text`}
                placeholder="Enter Discount"
                value={formik.values.variants?.[selectedVariant]?.unit_text || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                // error={Boolean(
                //   (formik.touched.variants as any)?.[selectedVariant]?.unit_text &&
                //   (formik.errors.variants as any)?.[selectedVariant]?.unit_text
                // )}

                // helperText={
                //   (formik.touched.variants as any)?.[selectedVariant]?.unit_text
                //     ? (formik.errors.variants as any)?.[selectedVariant]?.unit_text
                //     : ""
                // }
                error={Boolean(
                  getIn(formik.touched, `variants.${selectedVariant}.unit_text`) &&
                  getIn(formik.errors, `variants.${selectedVariant}.unit_text`)
                )}

                helperText={
                  getIn(formik.touched, `variants.${selectedVariant}.unit_text`)
                    ? getIn(formik.errors, `variants.${selectedVariant}.unit_text`)
                    : ""
                }
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} className='mt-3'>
              <Typography className='fw-bold input-label' variant='body2' gutterBottom>Min Delivery Days</Typography>
              <TextField
                fullWidth
                type='number'
                name={`variants.${selectedVariant}.min_delivery_days`}
                placeholder="Enter Min Days"
                value={formik.values.variants?.[selectedVariant]?.min_delivery_days || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                // error={Boolean(
                //   (formik.touched.variants as any)?.[selectedVariant]?.min_delivery_days &&
                //   (formik.errors.variants as any)?.[selectedVariant]?.min_delivery_days
                // )}

                // helperText={
                //   (formik.touched.variants as any)?.[selectedVariant]?.min_delivery_days
                //     ? (formik.errors.variants as any)?.[selectedVariant]?.min_delivery_days
                //     : ""
                // }
                error={Boolean(
                  getIn(formik.touched, `variants.${selectedVariant}.min_delivery_days`) &&
                  getIn(formik.errors, `variants.${selectedVariant}.min_delivery_days`)
                )}

                helperText={
                  getIn(formik.touched, `variants.${selectedVariant}.min_delivery_days`)
                    ? getIn(formik.errors, `variants.${selectedVariant}.min_delivery_days`)
                    : ""
                }
              />
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} className='mt-3'>
              <Typography className='fw-bold input-label' variant='body2' gutterBottom>Max Delivery Days</Typography>
              <TextField
                fullWidth
                type='number'
                name={`variants.${selectedVariant}.max_delivery_days`}
                placeholder="Enter Min Days"
                value={formik.values.variants?.[selectedVariant]?.max_delivery_days || ""}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                // error={Boolean(
                //   (formik.touched.variants as any)?.[selectedVariant]?.max_delivery_days &&
                //   (formik.errors.variants as any)?.[selectedVariant]?.max_delivery_days
                // )}

                // helperText={
                //   (formik.touched.variants as any)?.[selectedVariant]?.max_delivery_days
                //     ? (formik.errors.variants as any)?.[selectedVariant]?.max_delivery_days
                //     : ""
                // }
                error={Boolean(
                  getIn(formik.touched, `variants.${selectedVariant}.max_delivery_days`) &&
                  getIn(formik.errors, `variants.${selectedVariant}.max_delivery_days`)
                )}

                helperText={
                  getIn(formik.touched, `variants.${selectedVariant}.max_delivery_days`)
                    ? getIn(formik.errors, `variants.${selectedVariant}.max_delivery_days`)
                    : ""
                }
              />

            </Grid>
            <Grid size={{ xs: 12, md: 6 }} className='mt-3'>
              <Card elevation={0} className="bg-transparent border p-3 border-10">
                <Typography variant="h6" className="fw-bold mb-3">
                  Technical Details
                </Typography>

                <Grid container className="bg-grey p-2 mb-2">
                  <Grid size="grow">Key</Grid>
                  <Grid size="grow">Value</Grid>
                  <Grid size={{ xs: 1 }} />
                </Grid>

                {formik.values.variants[selectedVariant]?.technicalDetails?.map(
                  (item: any, index: number) => (
                    <Grid container spacing={1} key={index} className="mb-2 align-items-center">
                      <Grid size="grow">
                        <TextField
                          fullWidth
                          size="small"
                          placeholder="Key"
                          name={`variants.${selectedVariant}.technicalDetails.[${index}].key`}
                          value={item.key}
                          onChange={formik.handleChange}
                          error={Boolean(
                            getIn(formik.touched, `variants.${selectedVariant}.technicalDetails.${index}.key`) &&
                            getIn(formik.errors, `variants.${selectedVariant}.technicalDetails.${index}.key`)
                          )}

                          helperText={
                            getIn(formik.touched, `variants.${selectedVariant}.technicalDetails.${index}.key`)
                              ? getIn(formik.errors, `variants.${selectedVariant}.technicalDetails.${index}.key`)
                              : ""
                          }
                        />
                      </Grid>

                      <Grid size="grow">
                        <TextField
                          fullWidth
                          size="small"
                          placeholder="Value"
                          name={`variants.${selectedVariant}.technicalDetails.${index}.value`}
                          value={item.value}
                          onChange={formik.handleChange}
                          error={Boolean(
                            getIn(formik.touched, `variants.${selectedVariant}.technicalDetails.${index}.value`) &&
                            getIn(formik.errors, `variants.${selectedVariant}.technicalDetails.${index}.value`)
                          )}

                          helperText={
                            getIn(formik.touched, `variants.${selectedVariant}.technicalDetails.${index}.value`)
                              ? getIn(formik.errors, `variants.${selectedVariant}.technicalDetails.${index}.value`)
                              : ""
                          }
                        />
                      </Grid>

                      <Grid size={{ xs: 1 }} className="text-center">
                        <IconButton
                          color="error"
                          disabled={
                            formik.values.variants[selectedVariant].technicalDetails.length === 1
                          }
                          onClick={() => {
                            const data = [
                              ...formik.values.variants[selectedVariant].technicalDetails,
                            ];
                            data.splice(index, 1);

                            formik.setFieldValue(
                              `variants.${selectedVariant}.technicalDetails`,
                              data
                            );
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </Grid>
                    </Grid>
                  )
                )}

                <Button
                  startIcon={<Add />}
                  variant="outlined"
                  className="btn-outlined-main"
                  sx={{ mt: 1 }}
                  onClick={() => {
                    formik.setFieldValue(
                      `variants.${selectedVariant}.technicalDetails`,
                      [
                        ...formik.values.variants[selectedVariant].technicalDetails,
                        {
                          technicalDetailId: "",
                          key: "",
                          value: "",
                        },
                      ]
                    );
                  }}
                >
                  Add Technical Detail
                </Button>
              </Card>
            </Grid>
            <Grid size={{ xs: 12, md: 6 }} className='mt-3'>
              <Card elevation={0} className="bg-transparent border p-3 border-10">
                <Typography variant="h6" className="fw-bold mb-3">
                  Wholesale Price Tiers
                </Typography>
                <Grid container className="bg-grey p-2 mb-2">
                  <Grid size="grow">Min Quantity</Grid>
                  <Grid size="grow">Price (₹)</Grid>
                  <Grid size={{ xs: 1 }} />
                </Grid>

                {formik.values.variants[selectedVariant]?.wholesalePriceTiers?.map(
                  (item: any, index: number) => (
                    <Grid container spacing={1} key={index} className="mb-2 align-items-center">
                      <Grid size="grow">
                        <TextField
                          fullWidth
                          size="small"
                          type="number"
                          placeholder="Min Qty"
                          name={`variants.${selectedVariant}.wholesalePriceTiers.${index}.min_quantity`}
                          value={item.min_quantity}
                          onChange={formik.handleChange}
                          error={Boolean(
                            getIn(formik.touched, `variants.${selectedVariant}.wholesalePriceTiers.${index}.min_quantity`) &&
                            getIn(formik.errors, `variants.${selectedVariant}.wholesalePriceTiers.${index}.min_quantity`)
                          )}

                          helperText={
                            getIn(formik.touched, `variants.${selectedVariant}.wholesalePriceTiers.${index}.min_quantity`)
                              ? getIn(formik.errors, `variants.${selectedVariant}.wholesalePriceTiers.${index}.min_quantity`)
                              : ""
                          }
                        />
                      </Grid>

                      <Grid size="grow">
                        <TextField
                          fullWidth
                          size="small"
                          type="number"
                          placeholder="Price"
                          name={`variants.${selectedVariant}.wholesalePriceTiers.${index}.price`}
                          value={item.price}
                          onChange={formik.handleChange}
                          error={Boolean(
                            getIn(formik.touched, `variants.${selectedVariant}.wholesalePriceTiers.${index}.price`) &&
                            getIn(formik.errors, `variants.${selectedVariant}.wholesalePriceTiers.${index}.price`)
                          )}

                          helperText={
                            getIn(formik.touched, `variants.${selectedVariant}.wholesalePriceTiers.${index}.price`)
                              ? getIn(formik.errors, `variants.${selectedVariant}.wholesalePriceTiers.${index}.price`)
                              : ""
                          }
                        />
                      </Grid>

                      <Grid size={{ xs: 1 }} className="text-center">
                        <IconButton
                          color="error"
                          disabled={
                            formik.values.variants[selectedVariant].wholesalePriceTiers
                              .length === 1
                          }
                          onClick={() => {
                            const data = [
                              ...formik.values.variants[selectedVariant]
                                .wholesalePriceTiers,
                            ];
                            data.splice(index, 1);

                            formik.setFieldValue(
                              `variants.${selectedVariant}.wholesalePriceTiers`,
                              data
                            );
                          }}
                        >
                          <Delete fontSize="small" />
                        </IconButton>
                      </Grid>
                    </Grid>
                  )
                )}

                <Button
                  startIcon={<Add />}
                  variant="outlined"
                  className="btn-outlined-main"
                  sx={{ mt: 1 }}
                  onClick={() => {
                    formik.setFieldValue(
                      `variants.${selectedVariant}.wholesalePriceTiers`,
                      [
                        ...formik.values.variants[selectedVariant]
                          .wholesalePriceTiers,
                        {
                          tierId: "",
                          min_quantity: "",
                          price: "",
                        },
                      ]
                    );
                  }}
                >
                  Add Tier
                </Button>
              </Card>
            </Grid>
            <Grid size={{ xs: 12}} >
            <Box className="p-3 mb-2">
              <Typography variant="h6" className="fw-bold">
                Variant Images
              </Typography>

              <hr className="my-1" />

              <Grid container spacing={1.5} className="mt-4 ">
                <Grid size={{ xs: 12, md: "auto" }}>
                  <Box
                    className="p-4 d-flex flex-column border-10 justify-content-center text-center align-items-center"
                    sx={{
                      border: "2px dashed #d6d6d6",
                      cursor: "pointer",
                    }}
                    onClick={() => variantFileInputRef.current?.click()}
                  >
                    <CloudUploadOutlined sx={{ fontSize: 35, color: "#777" }} />

                    <Typography className="mt-1" variant="body1">
                      Drag & drop images here
                    </Typography>

                    <Typography className="my-1" variant="body2" color="text.secondary">
                      or
                    </Typography>

                    <Button
                      variant="outlined"
                      className="btn-outlined-main my-2"
                      size="small"
                      onClick={(e) => {
                        e.stopPropagation();
                        variantFileInputRef.current?.click();
                      }}
                    >
                      Upload Images
                    </Button>

                    <Typography
                      className="mt-1"
                      variant="caption"
                      color="text.secondary"
                      sx={{ fontSize: 10 }}
                    >
                      PNG or JPG. Max size 5MB
                    </Typography>

                    <input
                      ref={variantFileInputRef}
                      type="file"
                      hidden
                      multiple
                      accept="image/*"
                      onChange={handleVariantUpload}
                    />
                  </Box>
                </Grid>

                <Grid size={{ xs: 12, md: "grow" }}>
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "repeat(2,1fr)",
                        sm: "repeat(3,1fr)",
                        md: "repeat(4,1fr)",
                      },
                      gap: 2,
                    }}
                  >
                    {formik.values.variants[selectedVariant]?.images?.map(
                      (item: any, index: number) => (
                        <Box
                          key={index}
                          sx={{
                            border: "1px solid #e0e0e0",
                            borderRadius: 2,
                            overflow: "hidden",
                            position: "relative",
                            background: "#fff",
                            // height: 170,
                          }}
                        >
                          <IconButton
                            size="small"
                            sx={{
                              position: "absolute",
                              top: 5,
                              right: 5,
                              bgcolor: "#fff",
                              zIndex: 1,
                            }}
                            onClick={() => {
                              const images = [
                                ...formik.values.variants[selectedVariant].images,
                              ];

                              images.splice(index, 1);

                              formik.setFieldValue(
                                `variants.${selectedVariant}.images`,
                                images
                              );
                            }}
                          >
                            <Close fontSize="small" />
                          </IconButton>

                          <Box
                            component="img"
                            src={item.image_url}
                            alt={item.alt_text || `Variant ${index + 1}`}
                            sx={{
                              width: "100%",
                              // height: 120,
                              objectFit: "contain",
                              p: 1,
                            }}
                          />

                          {item.is_thumbnail && (
                            <Chip
                              label="Thumbnail"
                              color="success"
                              size="small"
                              sx={{
                                position: "absolute",
                                bottom: 8,
                                left: "50%",
                                transform: "translateX(-50%)",
                              }}
                            />
                          )}
                        </Box>
                      )
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Box>
            </Grid>
          </Grid>
        </Box>
        <Dialog
          open={openDeleteVariant}
          maxWidth="xs"
          fullWidth
          onClose={() => setOpenDeleteVariant(false)}
          slotProps={{
            paper: {
              sx: { borderRadius: "10px", p: 1 },
            },
          }}
        >
          <DialogContent sx={{ p: 2 }}>
            <Typography variant="h6" className="fw-bold mb-2">
              Delete Variant
            </Typography>
            <Typography variant="body2" className="mb-3">
              Are you sure you want to delete
              {" "}
              <b>{formik.values.variants?.[selectedVariant]?.name || `Variant ${selectedVariant + 1}`}</b>
              ? Its price tiers, technical details and images will be removed once you save the product.
            </Typography>
            <Box className="d-flex justify-content-end gap-2">
              <Button
                variant="outlined"
                className="btn-outlined-main"
                onClick={() => setOpenDeleteVariant(false)}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="error"
                onClick={handleDeleteVariant}
                disabled={!canDeleteVariant}
              >
                Delete
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openColor}
          maxWidth="sm"
          fullWidth
          slotProps={{
            paper: {
              sx: {
                width: 480,
                borderRadius: "10px",
                p: 1,
              },
            },
          }}
        >
          <DialogContent sx={{ p: 2 }}>
            {/* Header */}
            <Box className="d-flex align-items-center justify-content-between mb-3">
              <Typography variant="h6" className="fw-bold">
                Add Color
              </Typography>

              <IconButton size="small" onClick={handleCloseColor}>
                <CloseOutlined />
              </IconButton>
            </Box>

            {/* Color Name */}
            <Box className="mb-3">
              <Typography
                variant="body2"
                className="fw-bold mb-1"
              >
                Color Name <span style={{ color: "red" }}>*</span>
              </Typography>

              <TextField
                fullWidth
                size="small"
                placeholder="Enter color name"
                value={colorName}
                onChange={(e) => setColorName(e.target.value)}
              />
            </Box>

            <Box className="mb-3">
              <Typography
                variant="body2"
                className="fw-bold mb-1"
              >
                Hex Code <span style={{ color: "red" }}>*</span>
              </Typography>

              <Box className="d-flex align-items-center gap-2">
                <TextField
                  fullWidth
                  size="small"
                  placeholder="#000000"
                  value={hexCode}
                  onChange={(e) => setHexCode(e.target.value)}
                />

                <TextField
                  type="color"
                  value={hexCode}
                  onChange={(e) => setHexCode(e.target.value)}
                  sx={{
                    width: 60,
                    "& input": {
                      cursor: "pointer",
                      padding: "4px",
                      height: "40px",
                    },
                  }}
                />
              </Box>
            </Box>

            <Box className="d-flex justify-content-end gap-2">
              <Button
                variant="outlined"
                className="btn-outlined-main"
                onClick={handleCloseColor}
              >
                Cancel
              </Button>

              <Button
                className="btn-main"
                onClick={handleAddColor}
              >
                Save
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

        <Dialog
          open={openSize}
          maxWidth="sm"
          fullWidth
          slotProps={{
            paper: {
              sx: {
                width: 480,
                borderRadius: "10px",
                p: 1,
              },
            },
          }}
        >
          <DialogContent sx={{ p: 2 }}>
            {/* Header */}
            <Box className="d-flex align-items-center justify-content-between mb-3">
              <Typography variant="h6" className="fw-bold">
                Add Size
              </Typography>

              <IconButton size="small" onClick={handleCloseSize}>
                <CloseOutlined />
              </IconButton>
            </Box>

            {/* Size Name */}
            <Box className="mb-3">
              <Typography
                variant="body2"
                className="fw-bold mb-1"
              >
                Size Name <span style={{ color: "red" }}>*</span>
              </Typography>

              <TextField
                fullWidth
                size="small"
                placeholder="Enter size name"
                value={sizeName}
                onChange={(e) => setSizeName(e.target.value)}
              />
            </Box>

            {/* Buttons */}
            <Box className="d-flex justify-content-end gap-2">
              <Button
                variant="outlined"
                className="btn-outlined-main"
                onClick={handleCloseSize}
              >
                Cancel
              </Button>

              <Button
                className="btn-main"
                onClick={handleAddSize}
              >
                Save
              </Button>
            </Box>
          </DialogContent>
        </Dialog>

      </Box>
    )
      : (<></>)
  }

  export default VariantDetails